import { IItemRightsCollection, ItemRights } from "../../../Global/Base/Rights/RightTypes";
import { MutableItemRightsCollection } from "./MutableItemRightsCollection";

/**
 * Načítač práv, tak jak jsou definovány v XML definicích. Určeno pouze pro potřeby implementace {@link loadOriginalRightsDefinition}.
 * - K říjnu 2020 jsou tato práva uchovávána v dceřiných HTML elementech. Např. `<span data-tscitem="Rights.Required">`.
 * - Z těchto HTML elementů jsou načítána.
 * - Pozor: Reactí controls mažou tyto HTML elementy. Proto je třeba práva načíst ještě před jejich instanciací.
 */
export class OriginalRightsDefinitionLoaderFromHTML {
    public static load(element: HTMLElement): IItemRightsCollection {
        const rights = new MutableItemRightsCollection();

        const elementID = element.getAttribute("id");

        {
            //V elementu najdu první výskyt nastavení práv pro Visible
            const visible = element.querySelector("#" + elementID + "> span[data-tscitem='Rights.Visible']");
            //Hledám ve všech úrovních elementu, proto je potřeba zkontrolovat jestli výsledek patří k aktuálnímu elementu
            if (visible)
                rights.visible = OriginalRightsDefinitionLoaderFromHTML._extractRightsFromElementDefinition(visible);

            const showIfDef = element.getAttribute("rights.showifdefault");
            rights.showIfDefault = showIfDef == null ? false : showIfDef.toLowerCase() == "true";
        }

        {
            const enabled = element.querySelector("#" + elementID + "> span[data-tscitem='Rights.Enabled']");
            if (enabled)
                rights.enabled = OriginalRightsDefinitionLoaderFromHTML._extractRightsFromElementDefinition(enabled);
        }

        {
            const required = element.querySelector("#" + elementID + "> span[data-tscitem='Rights.Required']");
            if (required)
                rights.required = OriginalRightsDefinitionLoaderFromHTML._extractRightsFromElementDefinition(required);
        }

        {
            const postponedRequired = element.querySelector("#" + elementID + "> span[data-tscitem='Rights.PostponedRequired']");
            if (postponedRequired)
                rights.postponedRequired = OriginalRightsDefinitionLoaderFromHTML._extractRightsFromElementDefinition(postponedRequired);
        }

        {
            const recommended = element.querySelector("#" + elementID + "> span[data-tscitem='Rights.Recommended']");
            if (recommended)
                rights.recommended = OriginalRightsDefinitionLoaderFromHTML._extractRightsFromElementDefinition(recommended);
        }

        {
            const closeForm = element.querySelector("#" + elementID + "> span[data-tscitem='Rights.CloseForm']");
            if (closeForm)
                rights.closeForm = OriginalRightsDefinitionLoaderFromHTML._extractRightsFromElementDefinition(closeForm);
        }

        {
            const validateIf = element.querySelector("#" + elementID + "> span[data-tscitem='Rights.Validate']");
            if (validateIf)
                rights.validateIf = OriginalRightsDefinitionLoaderFromHTML._extractRightsFromElementDefinition(validateIf);
        }

        {
            const confirmIf = element.querySelector("#" + elementID + "> span[data-tscitem='Rights.Confirm']");
            if (confirmIf)
                rights.confirmIf = OriginalRightsDefinitionLoaderFromHTML._extractRightsFromElementDefinition(confirmIf);
        }

        {
            const useDigitalSign = element.querySelector("#" + elementID + "> span[data-tscitem='Rights.UseDigitalSign']");
            if (useDigitalSign)
                rights.useDigitalSign = OriginalRightsDefinitionLoaderFromHTML._extractRightsFromElementDefinition(useDigitalSign);
        }

        {
            const useEncryption = element.querySelector("#" + elementID + "> span[data-tscitem='Rights.UseEncryption']");
            if (useEncryption)
                rights.useEncryption = OriginalRightsDefinitionLoaderFromHTML._extractRightsFromElementDefinition(useEncryption);
        }

        {
            const useDecryption = element.querySelector("#" + elementID + "> span[data-tscitem='Rights.UseDecryption']");
            if (useDecryption)
                rights.useDecryption = OriginalRightsDefinitionLoaderFromHTML._extractRightsFromElementDefinition(useDecryption);
        }

        {
            const openAsEnabled = element.querySelector("#" + elementID + "> span[data-tscitem='Rights.OpenAsEnabled']");
            if (openAsEnabled)
                rights.openAsEnabled = OriginalRightsDefinitionLoaderFromHTML._extractRightsFromElementDefinition(openAsEnabled);
        }

        return rights;
    }

    private static _extractRightsFromElementDefinition(node: Element): ItemRights[] {
        const newItemRights = new Array<ItemRights>();

        for (let j = 0; j < node.childNodes.length; j++) {
            const aktNode: Element = node.childNodes[j] as Element;
            newItemRights.push(new ItemRights(aktNode));
        }

        return newItemRights;
    }
}
